<template>
<div>
    <!-- <top-nav title="组织机构"></top-nav> -->
  	<div class="cec-info">
			<img class="absolute-img" src="@/assets/images/cec2022/bird.png"/>
            
			<img src="@/assets/images/cec2022/meeting_infomation.png" style="margin-bottom: 30px;"/>
			<img src="@/assets/images/cec2022/org_title1.png" class="title"/>
			<div class="text">
				· 复旦大学附属中山医院<br />
				· 首都医科大学附属北京安贞医院<br />
				· 解放军总医院第一医学中心<br />
				· 海峡两岸医药卫生交流协会血管外科分会<br />
				· 中国研究型医院学会血管医学专业委员会<br />
				· 北京博瑞血管健康公益基金会<br />
			</div>
			<img src="@/assets/images/cec2022/org_title2.png" class="title" />
			<div class="text">
				· 复旦大学附属中山医院
			</div>
            <img src="@/assets/images/cec2022/org_title10.png" class="title"/>
				<div class="text">
				· 嘉睿鸿博（北京）国际文化发展有限责任公司<br />
				· 北京鼎瑞聚鑫科技有限公司<br />
				</div>
			<img src="@/assets/images/cec2022/org_title3.png" class="title"/>
			<div class="text">
				· 中国医师协会血管外科医师分会<br />
				· 中国医疗器械行业协会血管器械分会<br />
				· 北京医学会血管外科学分会<br />
				· 上海市医师协会血管外科医师分会<br />
				· 上海市医学会血管外科专科分会<br />
				·《中华血管外科杂志》<br />
				·《中华外科杂志》<br />
				·《中华医学杂志》<br />
				·《中华普通外科杂志》<br />
				·《中国实用外科杂志》<br />
				·《血管及腔内血管外科杂志》<br />
				·《中国血管外科杂志》（电子版）<br />
			</div>
            <img src="@/assets/images/cec2022/org_title11.png" class="title"/>
				<div class="text">
					· 上海翼得营销策划有限公司（血管资讯）<br />
					· 365 血管病网<br />
					·《门诊》杂志<br />
				</div>
			<img src="@/assets/images/cec2022/org_structure.png" style="margin-bottom: 30px;"/>
            
			<img src="@/assets/images/cec2022/org_title4.png" class="title"/>
			<div class="text">
				汪忠镐  中国人民解放军火箭军总医院<br />
				王玉琦  复旦大学附属中山医院<br />
				王深明  中山大学附属第一医院<br />
				樊  嘉  复旦大学附属中山医院院长<br />
				张宏家  首都医科大学附属北京安贞医院院长<br />
				徐迪雄  中国人民解放军总医院院长<br />
				王立基  海峡两岸医药卫生交流协会会长<br />
				何振喜  中国研究型医院学会会长<br />
			</div>
			<img src="@/assets/images/cec2022/org_title5.png" class="title"/>
			<div class="text">
				符伟国  复旦大学附属中山医院<br />
				陈  忠  首都医科大学附属北京安贞医院<br />
				郭  伟  中国人民解放军总医院<br />
			</div>
			<img src="@/assets/images/cec2022/org_title6.png" class="title"/>
			<div class="text">
				符伟国 复旦大学附属中山医院
			</div>
			<img src="@/assets/images/cec2022/org_title7.png" class="title"/>
			<div class="text">
				(按姓氏拼音排序)<br />
				曹贵松（上海） 陈翠菊（云南） 陈福真（上海） 陈国玉（江苏）<br />
				陈剑秋（天津） 陈韵岱（北京） 崔进国（河北） 董国祥（北京）<br />
				段志泉（辽宁） 葛均波（上海） 顾建平（江苏） 管　珩（北京）<br />
				韩雅玲（辽宁） 霍　勇（北京） 姜　峰（北京） 蒋米尔（上海）<br />
				金　毕（湖北） 金　星（山东） 景　华（江苏） 景在平（上海）<br />
				赖传善（湖北） 李大军（北京） 李俊海（天津） 李麟荪（江苏）<br />
				李　鸣（浙江） 李小鹰（北京） 栗　力（天津） 梁发启（北京）<br />
				林勇杰（广东） 刘希华（北京） 刘增庆（山西） 刘长建（江苏）<br />
				陆　民（上海） 吕柏楠（河北） 穆殿超（辽宁） 潘松龄（浙江）<br />
				潘　扬（贵州） 钱水贤（上海） 赛力克（新疆） 沈来根（浙江）<br />
				师天雄（广东） 时　德（重庆） 宋海屏（安徽） 苏　晞（湖北）<br />  
				滕皋军（江苏） 田利国（辽宁） 田　伟（北京） 汪忠镐（北京）<br />
				王发强（北京） 王建华（上海） 王　俊（广东） 王　烈（福建）<br />  
				王　杉（北京） 王深明（广东） 王仕华（北京） 王玉琦（上海）<br /> 
				吴庆华（北京） 吴性江（江苏） 吴肇光（上海） 肖湘生（上海）<br />
				熊吉信（江西） 徐　克（辽宁） 许樟荣（北京） 杨泽厚（湖南）<br />
				叶建荣（上海） 于振海（山东） 苑　超（北京） 张柏根（上海）<br />
				张国华（北京） 张纪蔚（上海） 张静菊（吉林） 赵同彬（北京）<br /> 
				赵玉沛（北京） 庄舜玖（上海） 祖茂衡（江苏）<br />

				
			</div>
			<img src="@/assets/images/cec2022/org_title8.png" class="title"/>
			<p class="red-text" style="margin-top: 20px;">国内成员</p>
			<div class="text">
				(按姓氏拼音排序)<br />
				安　君（吉林） 白云清（辽宁） 包俊敏（上海） 保　燕（云南）<br />	
				毕　伟（河北） 卞　策（北京） 蔡方刚（福建） 蔡铭智（福建）<br />	
				曹文东（山西） 曹烨民（上海） 曹忠文（吉林） 曾　嵘（北京）<br />	
				常光其（广东） 车海杰（山东） 陈　斌（上海） 陈　兵（浙江）<br />	
				陈　泉（广东） 陈　爽（上海） 陳偉華（台湾） 陈学明（北京）<br /> 
				陳沂名（台湾） 陈跃鑫（北京） 陈智勇（安徽） 陈　忠（北京）<br /> 
				成　军（重庆） 成　咏（上海） 程　才（湖北） 崔佳森（上海）<br /> 
				崔明哲（河南） 崔天雷（四川） 戴向晨（天津） 戴　毅（陕西）<br />  
				党永康(内蒙古）邓宏平（湖北） 邓洪儒（北京） 邓建平（广东）<br />  
				翟水亭（河南） 董红霖（山西） 董艳芬（北京） 董智慧（上海）<br />  
				杜　昕（北京） 樊雪强（北京） 范隆华（上海） 范卫东（河南）<br />  
				范新东（上海） 方　欣（浙江） 方　圆（上海） 方征东（安徽）<br />  
				冯　海（北京） 冯家烜（上海） 冯　骏（陕西） 冯　睿（上海）<br />  
				冯　薇（辽宁） 冯　翔（上海） 冯曜宇（云南） 冯自波（湖北）<br /> 
				符伟国（上海） 傅麒宁（重庆） 高　斌（上海） 高　翔（北京）<br /> 
				高　涌（安徽） 高　远（北京） 高　众（辽宁） 戈小虎（新疆）<br /> 
				葛阳阳（北京） 龚昆梅（云南） 谷涌泉（北京） 顾洪斌（北京）<br /> 
				官云彪（福建） 管　强（山西） 管　圣（新疆） 郭宝磊（上海）<br /> 
				郭大乔（上海） 郭发才（兰州） 郭建辉（云南） 郭连瑞（北京）<br /> 
				郭明金（山东） 郭平凡（福建） 郭曙光（云南） 郭　伟（北京）<br /> 
				郭相江（上海） 韩　锋（山西） 韩文豪（河南） 郝　斌（山西）<br /> 
				郝迎学（重庆） 何春水（四川） 何　菊（天津） 何　楠（北京）<br /> 
				何　强（贵州） 洪诗钗（福建） 胡春芳（重庆） 胡凡果（天津）<br /> 
				胡何节（安徽） 胡　佳（四川） 胡志鹏（宁夏） 胡智飞（北京）<br /> 
				胡忠洲（北京） 华正东（湖北） 化召辉（河南） 黄　斌（四川）<br /> 
				黄建华（湖南） 黄金旗（福建） 黄景勇（浙江） 黄连军（北京）<br /> 
				黄　玲（江西） 黄柳桓（北京） 黄　文（重庆） 黄小进（福建）<br />
				黄小勇（北京） 黄晓钟（上海） 黄新天（上海） 纪东华（辽宁）<br /> 
				贾　琪（辽宁） 贾森皓（北京） 贾　伟（北京） 贾　鑫（北京）<br /> 
				姜剑军（山东） 姜维良（黑龙江)蒋劲松（浙江） 蒋俊豪（上海）<br /> 
				蒋岚杉（四川） 蒋　鹏（北京） 金　辉（广东） 金　璐（浙江）<br /> 
				金其庄（北京） 金　炜（浙江） 荆玉辰（辽宁） 鞠　上（北京）<br /> 
				柯博仁（台湾） 寇　镭（北京） 郎德海（浙江） 黎　明（湖南）<br /> 
				李春民（北京） 李丹丹（江苏） 李栋林（浙江） 李凤贺（重庆）<br /> 
				李　刚（湖南） 李光新（山东） 李海磊（广东） 李海燕（上海）<br /> 
				李　慧（北京） 李　雷（北京） 李　黎（上海） 李　林（山东）<br /> 
				李　霖（浙江） 李茂全（上海） 李　庞（广东） 李　强（山东）<br /> 
				李清乐（北京） 李天润（北京） 李　婷（福建） 李维敏（上海）<br /> 
				李　伟（北京） 李炜淼（上海） 李晓光（福建） 李晓强（江苏）<br /> 
				李　选（北京） 李毅清（湖北） 李拥军（北京） 李玉斌（山东）<br /> 
				李　震（河南） 李梓伦（广东） 廉维帅（上海） 梁刚柱（北京）<br /> 
				梁　卫（上海） 林佳勳（台湾） 林　江（上海） 林　梅（北京）<br /> 
				林少芒（广东） 林小雷（福建） 林　越（福建） 林长泼（上海）<br /> 
				刘　暴（北京） 刘　冰（黑龙江)刘博文（北京） 刘昌伟（北京）<br /> 
				刘　光（上海） 刘　灏（广东） 刘　晖（北京） 刘建林（陕西）<br /> 
				刘建龙（北京） 刘　杰（北京） 刘军军（山东） 刘丽萍（重庆）<br /> 
				刘　玲（北京） 刘　鹏（北京） 刘仁贵（云南） 刘小平（北京）<br /> 
				刘晓兵（上海） 刘晓琳（北京） 刘晓艳（四川） 刘训强（云南）<br /> 
				刘杨东（广东） 刘　勇（四川） 刘　昭（江苏） 刘兆玉（辽宁）<br /> 
				刘震杰（浙江） 楼文胜（江苏） 卢辉俊（江苏） 卢伟锋（福建）<br /> 
				陆明晰（浙江） 陆清声（上海） 陆　炜（浙江） 陆信武（上海）<br />  
				禄韶英（陕西） 栾景源（北京） 栾韶亮（北京） 罗灿华（广东）<br />  
				罗家音（北京） 罗建方（广东） 罗剑钧（上海） 罗　军（新疆）<br />  
				罗明尧（北京） 罗小云（北京） 马　强（陕西） 马　韬（上海）<br />  
				马　翔（新疆） 马晓辉（北京） 马玉奎（四川） 梅　菲（湖北）<br />  
				梅家才（上海） 梅志军（上海） 门剑龙（天津） 孟庆义（山东）<br />  
				孟庆友（上海） 米兰化（上海） 牟德堂（山东） 缪建航（广东）<br />  
				缪　鹏（北京） 倪　冷（北京） 倪其泓（上海） 倪叶彬（上海）<br />  
				牛鹿原（北京） 欧敬民（上海） 欧明辉（山东） 欧阳晨曦(北京)<br /> 
				潘天岳（上海） 潘以锋（浙江） 亓　明（辽宁） 齐加新（山东）<br />  
				钱爱民（江苏） 乔　彤（江苏） 乔永辉（浙江） 秦　峰（上海）<br />  
				秦　皓（陕西） 秦　晶（河南） 秦永林（江苏） 曲乐丰（上海）<br />  
				冉　峰（江苏） 任补元(内蒙古）任　丽（四川） 容　丹（北京）<br />  
				桑宏飞（江苏） 商　弢（浙江） 沈晨阳（北京） 沈佩儿（浙江）<br />  
				沈文彬（北京） 沈谢冬（上海） 施俊哲（台湾） 施　敏（河南）<br />  
				施娅雪（上海） 石　赟（上海） 史伟浩（上海） 史亚东（江苏）<br />  
				史振宇（上海） 舒　畅（北京） 舒小军（甘肃） 司　逸（上海）<br />  
				宋　超（上海） 宋　玲（北京） 宋　燕（河南） 蘇大維（台湾）<br />  
				孙国义（北京） 孙建明（重庆） 覃　晓（广西） 覃　忠（广西）<br />  
				谭晋韵（上海） 谭正力（北京） 汤敬东（上海） 唐金红（江西）<br />  
				唐　骁（上海） 唐小斌（北京） 田红燕（陕西） 田　路（浙江）<br />  
				田　文（上海） 田　轩（北京） 田　野（新疆） 佟　铸（北京）<br />  
				万　恒（广东） 王　兵（河南） 王昌明（北京） 王贵明（山西）<br />  
				王国权（河南） 王海洋（广东） 王豪夫（山东） 王　剑（浙江）<br />  
				王劲松（广东） 王　磊（北京） 王利新（上海） 王　亮（福建）<br />  
				王　冕（上海） 王　沛（河南） 王　盛（北京） 王维慈（湖北）<br />  
				王　伟（湖南） 王　炜（江苏） 王歆淏（北京） 王　旭（山东）<br />  
				王宇飞（河南） 王占启（北京） 王　哲（重庆） 卫　任（北京）<br />  
				魏小龙（上海） 翁艳敏（江苏） 吴丹明（辽宁） 吴　昊（浙江）<br />  
				吴继东（北京） 吴　蕊（北京） 吴巍巍（北京） 吴学君（山东）<br />  
				吴章敏（北京） 吴子衡（浙江） 吳毅暉（台湾） 肖光辉（北京）<br />  
				肖　航（重庆） 肖丽艳（湖南） 肖占祥（海南） 辛世杰（北京）<br />  
				邢　彤（北京） 熊　飞（四川） 熊　江（北京） 熊小蔚（江西）<br />  
				徐　欣（上海） 许慧平（内蒙古)许　浏（浙江） 许永乐（北京）<br />  
				许中友（浙江） 续慧民（山西） 薛冠华（上海） 闫　波（宁夏）<br />  
				杨宝钟（北京） 杨　斌（云南） 杨　超（湖北） 杨澄宇（广东）<br />  
				杨宏宇（江苏） 杨　进（浙江） 杨　珏（上海） 杨　燎（北京）<br />  
				杨　林（陕西） 杨　淼（北京） 杨　敏（北京） 杨　牟（山东）<br />  
				杨硕菲（上海） 杨　涛（山西） 杨耀国（北京） 杨　轶（四川）<br />  
				杨　镛（云南） 姚　陈（广东） 叶　红（江苏） 叶开创（上海）<br />  
				叶　猛（上海） 叶　炜（北京） 叶志东（北京） 殷恒讳（广东）<br />  
				殷敏毅（上海） 尹　杰（北京） 尤庆生（北京） 余　波（上海）<br />  
				余朝文（安徽） 虞　奋（上海） 虞冠锋（浙江） 虞正红（上海）<br />  
				郁正亚（北京） 喻　英（山西） 袁　丁（四川） 袁　海（山东）<br />  
				袁良喜（上海） 袁　平（贵州） 袁时芳（陕西） 原　野（江苏）<br />  
				岳嘉宁（上海） 詹　申（北京） 张东明（辽宁） 张　峰（河北）<br />  
				张福先（北京） 张宏鹏（北京） 张鸿坤（浙江） 張兼華（台湾）<br />  
				张　健（北京） 张　杰（北京） 张精勇（山东） 张凯捷（浙江）<br />  
				张　岚（上海） 张　雷（河南） 张　磊（河北） 张立魁（辽宁）<br />  
				张　丽（山东） 张敏宏（北京） 张　明（江苏） 张　强（上海）<br />  
				张　荣（福建） 张十一（山东） 张曙光（山东） 张素真（福建）<br />  
				张　韬（北京） 张腾飞（北京） 张　婷（上海） 张　童（北京）<br />  
				张望德（北京） 张　雯（上海） 张喜成（江苏） 张喜维（北京）<br />  
				张显岚（广西） 张小明（北京） 张秀军（天津） 张学民（北京）<br />  
				张　艳（广东） 张玉惠（浙江） 张玉侠（上海） 张　章（陕西）<br /> 
				张　征（北京） 张智辉（广东） 章希炜（江苏） 赵得银（安徽）<br /> 
				赵纪春（四川） 赵　珺（上海） 赵　亮（北京） 赵堂海（山东）<br /> 
				赵文军（浙江） 赵　霞（重庆） 赵艳平（江西） 赵意平（上海）<br /> 
				赵　渝（重庆） 赵志青（上海） 赵　中（浙江） 郑永强（香港）<br /> 
				郑有卯（浙江） 郑月宏（北京） 钟红珊（辽宁） 钟　鸣（上海）<br /> 
				种振岳（山东） 仲秋利（云南） 周大勇（江苏） 周建华（云南）<br /> 
				周　瑾（北京） 周　敏（江苏） 周　庆（江苏） 周　卫（江西）<br /> 
				周为民（江西） 周　游（北京） 周玉斌（辽宁） 周忠信（广州）<br /> 
				朱化刚（安徽） 朱越锋（浙江） 朱云峰（江苏） 竺　挺（上海）<br /> 
				庄百溪（北京） 庄　晖（福建） 邹君杰（江苏） 邹英华（北京）<br /> 
				左　健（陕西） <br />
			</div>
			<p class="red-text">国际成员</p>
			<div class="text">
				(按英文字母顺序排序)<br />
				<div class="name">Adel Barkat(美国)</div><div class="name">Andrej Schmid(德国)</div>
				<div class="name">Anthony Comerota(美国)</div><div class="name">Axel Fischer(德国)</div>
				<div class="name">Brian G. DeRubertis(美国)</div><div class="name">Caitlin Whitney Hicks(美国)</div>
				<div class="name">Carlos Timaran(美国)</div><div class="name">Dierk Scheinert(德国)</div>
				<div>Efthymios (Makis) Avgerinos(希腊)</div><div class="name">Enrico Ascher(美国)</div>
				<div class="name">Erin Murphy(美国)</div><div class="name">Frank J. Veith(美国)</div>
				<div class="name">Glenn Jacobowitz(美国)</div><div class="name">Gregory Stanley(美国)</div>
				<div class="name">Gustavo Oderich(美国)</div><div class="name">Jacques Busquet(法国)</div>
				<div class="name">Jason T. Lee(美国)</div><div>Josua Cornelis van den Berg(瑞士)</div>
				<div class="name">Kathleen Gibson(美国)</div><div class="name">Maarit Venermo(芬兰)</div>
				<div class="name">Manuela Konert(德国)</div><div class="name">Martin Björck(瑞典)</div>
				<div class="name">Masaaki Murakami(日本)</div><div class="name">Mehdi Shishehbor(美国)</div>
				<div class="name">Michael D. Dake(美国)</div><div class="name">Michel Bosiers(德国)</div>
				<div class="name">Narayanan Thulasidasan(英国)</div><div class="name">Ng Jun Jie(新加坡)</div>
				<div class="name">Osama Iida(日本)</div><div class="name">Patrick Muck(美国)</div>
				<div class="name">Peter Schneider(美国)</div><div class="name">Pua Uei(新加坡)</div>
				<div class="name">Roberto Ferraresi(意大利)</div><div class="name">Roger Greenhalgh(英国)</div>
				<div class="name">Ross Milner(美国)</div><div class="name">Sabine Steiner(德国)</div>
				<div class="name">Sandra Düsing(德国)</div><div class="name">Sang-Su Lee(韩国)</div>
				<div class="name">Stephen Black(美国)</div><div class="name">Suk-Won Song(韩国)</div>
				<div class="name">Thomas Maldonado(美国)</div><div class="name">Thomas Zeller(德国)</div>
				<div class="name">Tony Gasparis(美国)</div><div class="name">Vincent Jongkind(荷兰)</div>
				<div class="name">William Marston(美国)</div><div class="name">Yoshimitsu Soga(日本)</div>
				<div class="name">何蓓 Jackie Ho Pei(新加坡)</div><div class="name">张玮 Wayne Zhang(美国)</div>
				<div class="name">纪永威 Willy Chi(美国)</div>
			</div>

			<img src="@/assets/images/cec2022/org_title20.png" class="title"/>
			<div class="text" style="margin-top:0px;">
				(按姓氏拼音排序)<br />
				艾文佳（广东） 陈志鹏（江苏） 崔超毅（上海） 方　坤（北京）<br />	
				关自真（香港） 郭义龙（北京） 胡诚凯（上海） 胡忠洲（北京）<br />	
				蒋小浪（上海） 李宪伟（黑龙江)李云峰（北京） 梁　飞（北京）<br />	
				乔冠宇（上海） 秦金保（上海） 容　丹（北京） <br />
				<div class="name">苏比努尔买买提艾力（江苏）</div>田　晨（北京） 王嘉宾（北京） <br />
				王睿涵（上海） 吴明炜（北京） 徐一丁（广东） 徐益鸣（福建）<br /> 
				杨　燎（北京） 张建彬（北京） 张　雷（上海） 张薛欢（北京）<br /> 
				郑　毅（广西） 周志伟（福建）<br />	
			</div>
			<img src="@/assets/images/cec2022/org_title9.png" class="title"/>
			<div class="text">
				<p class="red-text" style="margin-top: 20px;">主任委员</p>
					郭大乔（上海） 唐小斌（北京） 熊  江（北京）<br />
				<p class="red-text" style="margin-top: 20px;">秘书长</p>
					岳嘉宁（上海） 杨　燎（北京） 张宏鹏（北京）<br />
				<p class="red-text" style="margin-top: 20px;">成员</p>
					(按姓氏拼音排序)<br />
					丁　勇（上海） 方　超（上海） 方　刚（上海） 方　圆（上海）<br />  
					高　斌（上海） 葛阳阳（北京） 郭宝磊（上海） 胡智飞（北京）<br />  
					胡忠洲（北京） 贾森浩（北京） 贾　鑫（北京） 蒋俊豪（上海）<br />  
					阚远晴（上海） 李　慧（北京） 李炜淼（上海） 李　洋（北京）<br />  
					林长泼（上海） 刘博文（北京） 刘　杰（北京） 刘　硕（北京）<br />  
					卢卫航（北京） 栾靖旸（上海） 马　韬（上海） 马晓辉（北京）<br />  
					毛　乐（上海） 孟　怡（北京） 潘天岳（上海） 容　丹（北京）<br /> 
					石　赟（上海） 司　逸（上海） 孙国义（北京） 唐涵斐（上海）<br /> 
					唐　骁（上海） 王　静（北京） 王清媛（北京） 王　硕（北京）<br />  
					王晓娜（北京） 王歆淏（北京） 王占启（北京） 卫　任（北京）<br />  
					许永乐（北京） 杨　珏（上海） 杨　燎（北京） 叶诗雯（上海）<br />  
					虞　奋（上海） 原　通（上海） 岳嘉宁（上海） 张　弛（北京）<br />  
					张宏鹏（北京） 张敏宏（北京） 张腾飞（北京） 张　雯（上海）<br />  
					张　征（北京） 郑焕勤（北京） 周　旻（上海） 周　游（北京）<br />  
			</div>
		</div>
		<!-- <img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/> -->
</div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import {ButtonDetail} from '../../config/interface.js'
export default {
    components:{
        topNav
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
     methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        }
    }
}
</script>

<style scoped>
.bg{
    background: white;
    margin-top: 48px;
}
.cec-info{
	padding: 30px 25px;
	position: relative;
}
.cec-info img{
	width: 100%;
}
.cec-info .absolute-img{
	position: absolute;
	top:30px;
	left: 0;
}
.cec-info .red-text{
	color: #B2312E;
}
.cec-info .text{
	margin: 10px 0 30px;
	font-size: 0.28rem;
	line-height: 22px;
}
.cec-info .text .name{
	width: 49%;
	display: inline-block;
}
.cec-info .line1{
	line-height: 40px;
}
.cec-info .line1 img{
	width: 20px;
	vertical-align: middle;
	line-height: 40px;
	margin-right: 10px;
}

.bottom-img{
    width: 100%;
    display: block;
}

</style>


// WEBPACK FOOTER //
// src/pages/cec2022/organizor.vue